import { render, staticRenderFns } from "./BeneficiosList.vue?vue&type=template&id=2a5cce1a&scoped=true&"
import script from "./BeneficiosList.vue?vue&type=script&lang=js&"
export * from "./BeneficiosList.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiosList.vue?vue&type=style&index=0&id=2a5cce1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5cce1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
